(() => {
  const SELECTOR = '.footer__collapsible-summary';
  const DESKTOP_MQ = window.matchMedia('(min-width: 700px)');

  function onClick(event) {
    if (DESKTOP_MQ.matches) return;
    const button = event.target.closest(SELECTOR);
    if (!button) return;
    event.preventDefault();
    const expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
  }

  function syncForViewport() {
    if (!DESKTOP_MQ.matches) return;
    document.querySelectorAll(SELECTOR).forEach((btn) => {
      btn.setAttribute('aria-expanded', 'true');
    });
  }

  function init() {
    document.addEventListener('click', onClick);
    DESKTOP_MQ.addEventListener('change', syncForViewport);
    syncForViewport();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
